/* get data */
export const GET_SCHEDULER_INTERVIEW_DETAILS =
  "GET_SCHEDULER_INTERVIEW_DETAILS";
export const GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS =
  "GET_SCHEDULER_INTERVIEW_DETAILS_SUCCESS";
export const GET_SCHEDULER_INTERVIEW_DETAILS_FAIL =
  "GET_SCHEDULER_INTERVIEW_DETAILS_FAIL";

/**Update interview details */
export const UPDATE_INTERVIEW_DETAILS = "UPDATE_INTERVIEW_DETAILS";
export const UPDATE_INTERVIEW_DETAILS_SUCCESS =
  "UPDATE_INTERVIEW_DETAILS_SUCCESS";
export const UPDATE_INTERVIEW_DETAILSS_FAIL = "UPDATE_INTERVIEW_DETAILS_FAIL";

/*get interview rounds*/
export const GET_INTERVIEW_ROUNDS_SUCCESS = "GET_INTERVIEW_ROUNDS_SUCCESS";
export const GET_INTERVIEW_ROUNDS_FAILURE = "GET_INTERVIEW_ROUNDS_FAILURE";
export const GET_INTERVIEW_ROUNDS = "GET_INTERVIEW_ROUNDS";

/**schedule interview */
export const SCHEDULE_INTERVIEW = "RESCHEDULE_INTERVIEW";
export const SCHEDULE_INTERVIEW_SUCCESS = "SCHEDULE_INTERVIEW_SUCCESS";
export const SCHEDULE_INTERVIEW_FAILURE = "SCHEDULE_INTERVIEW_FAILURE";
export const SCHEDULE_VIDEO_INTERVIEW = "SCHEDULE_VIDEO_INTERVIEW";

/**reschedule interview */
export const RESCHEDULE_INTERVIEW = "RESCHEDULE_INTERVIEW";
export const RESCHEDULE_INTERVIEW_SUCCESS = "RESCHEDULE_INTERVIEW_SUCCESS";
export const RESCHEDULE_INTERVIEW_FAILURE = "RESCHEDULE_INTERVIEW_FAILURE";

//add interviewer round
export const POST_INTERVIEW_ROUND = "POST_INTERVIEW_ROUND";
export const POST_INTERVIEW_ROUND_SUCCESS = "POST_INTERVIEW_ROUND_SUCCESS";
export const POST_INTERVIEW_ROUND_FAIL = "POST_INTERVIEW_ROUND_FAIL";

//Video Integration Hireneuron
export const HIRENEURON_VIDEO_INTEGRATION = "HIRENEURON_VIDEO_INTEGRATION";
export const HIRENEURON_VIDEO_INTEGRATION_FAIL =
  "HIRENEURON_VIDEO_INTEGRATION_FAIL";
export const HIRENEURON_VIDEO_INTEGRATION_SUCCESS =
  "HIRENEURON_VIDEO_INTEGRATION_SUCCESS";

// get interviewer list data
export const GET_INTERVIEWERS_DATA = "GET_INTERVIEWERS_DATA";
export const GET_INTERVIEWERS_DATA_SUCCESS = "GET_INTERVIEWERS_DATA_SUCCESS";
export const GET_INTERVIEWERS_DATA_ERROR = "GET_INTERVIEWERS_DATA_ERROR";

export const ADD_NEW_INTERVIEWER = "ADD_NEW_INTERVIEWER";
export const ADD_NEW_INTERVIEWER_SUCCESS = "ADD_NEW_INTERVIEWER_SUCCESS";
export const ADD_NEW_INTERVIEWER_FAILED = "ADD_NEW_INTERVIEWER_FAILED";
// reject candidate
export const REJECT_CANDIDATE = "REJECT_CANDIDATE";
export const REJECT_CANDIDATE_FAILURE = "REJECT_CANDIDATE_FAILURE";
export const REJECT_CANDIDATE_SUCCESS = "REJECT_CANDIDATE_SUCCESS";

// AI Interview Recordings
export const GET_INTERVIEW_RECORDINGS = "GET_INTERVIEW_RECORDINGS";
export const GET_INTERVIEW_RECORDINGS_SUCCESS =
  "GET_INTERVIEW_RECORDINGS_SUCCESS";
export const GET_INTERVIEW_RECORDINGS_FAILURE =
  "GET_INTERVIEW_RECORDINGS_FAILURE";
